(function () {
  let swiper;

  function init() {
    const list = document.querySelector('.bi-featured-cards__list');
    const blocksSize = list.dataset.blocksSize;

    swiper = new Swiper('.bi-featured-cards .swiper', {
      speed: 800,
      slidesPerView: 1.4,
      lazyPreloadPrevNext: 1,
      spaceBetween: 8,
      loopAddBlankSlides: false,
      slidesOffsetBefore: blocksSize > 3 ? 0 : 15,
      slidesOffsetAfter: blocksSize > 3 ? 0 : 15,
      loop: blocksSize > 3 ? true : false,
      centeredSlides: blocksSize > 3 ? true : false,
      breakpoints: {
        425: {
          slidesPerView: 1.6,
        },
        576: {
          slidesPerView: 2.6,
        },
        768: {
          slidesPerView: blocksSize > 3 ? 3.2 : 3,
          slidesOffsetBefore: blocksSize > 2 ? 0 : 15,
          slidesOffsetAfter: blocksSize > 2 ? 0 : 15,
          loop: blocksSize > 5 ? true : false,
          centeredSlides: blocksSize > 5 ? true : false,
        },
        992: {
          slidesPerView: blocksSize > 3 ? 3.6 : 3,
          spaceBetween: 16,
          slidesOffsetBefore: blocksSize > 2 ? 0 : 15,
          slidesOffsetAfter: blocksSize > 2 ? 0 : 15,
          loop: blocksSize > 4 ? true : false,
          centeredSlides: blocksSize > 5 ? true : false,
        },
        1200: {
          slidesPerView: blocksSize > 4 ? 4.2 : 4,
          spaceBetween: 16,
          slidesOffsetBefore: blocksSize > 3 ? 0 : 15,
          slidesOffsetAfter: blocksSize > 3 ? 0 : 15,
          loop: blocksSize > 4 ? true : false,
          centeredSlides: blocksSize > 5 ? true : false,
        },
      },
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', (e) => {
    if (!e.target.classList.contains('bi-featured-cards__item')) return;

    const slides = document.querySelectorAll('.bi-featured-cards__list li');

    slides?.forEach((currentSlide, currentIndex) => {
      if (e.target === currentSlide) {
        if (swiper.params.loop) {
          swiper.slideToLoop(currentSlide.dataset.swiperSlideIndex);
        } else {
          swiper.slideTo(currentIndex);
        }
      }
    });
  });
})();
